/**
 * Возвращает базовый (статический) путь текущего маршрута — без slug'ов.
 * Например, для `/guides/foo/bar` и маршрута `/guides/:subroute/:subsubroute` вернёт `/guides`
 */
export function useStaticBasePath(): string {
  const route = useRoute();
  const router = useRouter();

  const matchedRoute = route.matched[0];
  if (!matchedRoute) {
    return route.path;
  }

  const routeDef = router.options.routes.find((r) => r.name === matchedRoute.name);

  if (!routeDef || typeof routeDef.path !== 'string') {
    return route.path;
  }

  const pathTemplate = routeDef.path;

  return pathTemplate.split('/:')[0];
}
